import { Page } from '../Page/';
import { SkeletonBox } from './SkeletonBox';
import { SkeletonText } from './SkeletonText';

interface ISkeletonPageProps {
    children?: React.ReactNode;
    title?: string | true;
    breadcrumbs?: boolean;
    actions?: boolean;
    subtitle?: boolean;
    fullWidth?: boolean;
    background?: "white" | "gray";
    loading?: boolean;
}

export const SkeletonPage: React.FC<React.PropsWithChildren<ISkeletonPageProps>> = ({
    title,
    subtitle = false,
    actions = false,
    breadcrumbs  = false,
    children,
    fullWidth = false,
    background = "gray",
    loading = false
}) => {

    return (
        <>
            <Page
                title={title === true ? <SkeletonText lines={1} width={200} variant='heading' /> : title}
                subtitle={subtitle &&
                    <SkeletonText lines={1} width={350} />
                }
                actions={actions && <SkeletonBox height={40} width={100} />}
                breadcrumbs={breadcrumbs && <SkeletonBox height={20} width={180} />}
                fullWidth={fullWidth}
                background={background}
                loading={loading}
                >
                {children}
            </Page>

        </>
    );
};